"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorTypeEnum = void 0;
var VendorTypeEnum;
(function (VendorTypeEnum) {
    VendorTypeEnum["VENDOR"] = "Vendor";
    VendorTypeEnum["USER"] = "User";
})(VendorTypeEnum || (exports.VendorTypeEnum = VendorTypeEnum = {}));
